import React, { useState } from "react";
import "../../assets/styles/components/_login.scss";
import useForm from "../../hooks/useForm";
import clienteAxios from "../../config/clienteAxios";
import logo from "../../assets/images/brand/Tensolite-Isologotipo-blanco.png";
import { professionOptions } from "../../exports/professions";
import { toast } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Modal } from "react-bootstrap";
import ModalLogin from "./ModalLogin";

const Register = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [terms, setTerms] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const navigate = useNavigate();
  const { values, setValues, handleInputChange, reset } = useForm({
    name: "",
    email: "",
    password: "",
    profession: "",
    terms: false,
    role: "Usuario",
  });
  const [alert, setAlert] = useState({
    class: "",
    message: "",
  });

  const handleCheckTerms = ({ target }) => {
    setTerms(!terms);
    setValues({
      ...values,
      [target.name]: !terms,
    });
  };

  const [showGaleria, setShowGaleria] = useState(false);
  const handleCloseGaleria = () => setShowGaleria(false);
  const handleShowGaleria = () => setShowGaleria(true);

  const handleModalClick = () => {
    handleShowGaleria();
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const handleSubmit = async (event) => {
    event.preventDefault();

    let checkName = false;
    let checkProfession = false;
    let checkEmail = false;
    let checkPassword = false;
    let checkTerms = false;

    if (values.name !== "") {
      checkName = true;
    }

    if (values.profession !== "") {
      checkProfession = true;
    }

    if (values.email !== "") {
      checkEmail = true;
    }

    if (values.password !== "") {
      checkPassword = true;
    }

    if (values.terms !== false) {
      checkTerms = true;
    } else {
      toast.error("Debes aceptar los términos y condiciones");
    }

    if (
      checkName &&
      checkProfession &&
      checkEmail &&
      checkPassword &&
      checkTerms
    ) {
      try {
        await clienteAxios.post("/user", values);
        toast.success("Usuario creado correctamente!");
        navigate(
          queryParams.toString().length > 0
            ? `/clientes/login?${queryParams.toString()}`
            : "/clientes/login"
        );
        reset();
      } catch (error) {
        toast.error(error.response.data.msg);
      }
    }
  };
  return (
    <>
      <form className="container register__card-form" onSubmit={handleSubmit}>
        <Modal
          id="galleryModal"
          className="modalContenedor__galeria"
          show={showGaleria}
          onHide={handleCloseGaleria}
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <ModalLogin handleCloseGaleria={handleCloseGaleria} />
          </Modal.Body>
        </Modal>
        <div className="logo-register">
          <img src={logo} alt="Logo Tensolite" className="logo" />
        </div>
        {alert?.class?.length > 0 ? (
          <div className={`flex-row ${alert.class}`} role="alert">
            {alert?.message}
          </div>
        ) : null}
        <div className="flex-row register__input">
          <input
            type="text"
            name="name"
            id="name"
            className={`lf--input clients_input form-control `}
            placeholder="Nombre y apellido"
            value={values.name}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="invalid-feedback">nombre requerido</div>
        <div className="flex-row register__input">
          <select
            name="profession"
            className={`lf--input clients_input form-control `}
            id="profession"
            onChange={handleInputChange}
            required
            defaultValue
          >
            {professionOptions?.map((option, index) =>
              index === 0 ? (
                <option key={index} value={option.value} selected>
                  {option.label}
                </option>
              ) : (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              )
            )}
          </select>
        </div>
        <div className="flex-row register__input">
          <input
            type="text"
            id="email"
            name="email"
            className={`lf--input clients_input form-control `}
            placeholder="Email"
            value={values.email}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="flex-row register__input clients_input_password ">
          <input
            maxLength={12}
            type={showPassword ? "text" : "password"}
            id="password"
            name="password"
            className={`lf--input clients_input form-control `}
            placeholder="Contraseña"
            value={values.password}
            onChange={handleInputChange}
            required
          />

          <button type="button" className="" onClick={toggleShowPassword}>
            {showPassword ? (
              <VisibilityOffIcon
                sx={{
                  color: "white",
                }}
              />
            ) : (
              <VisibilityIcon
                sx={{
                  color: "white",
                }}
              />
            )}
          </button>
        </div>
        <div className="check-terms">
          <FormControlLabel
            control={<Checkbox checked={terms} />}
            label="Entiendo y Acepto los Términos y Condiciones"
            name="terms"
            onChange={handleCheckTerms}
            value={terms}
          />
          <HelpOutlineIcon
            className="icon-info"
            onClick={() => handleModalClick()}
          />
        </div>
        <input
          type="submit"
          className="lf--submit mx-md-auto mt-3"
          value="REGISTRAR"
        />
      </form>
    </>
  );
};

export default Register;
